import { Outlet } from 'react-router-dom';

import { NavigationLevelGuard } from '@/app/navigation-context/navigation-level-guard.js';
import { RequirePlace } from '@/app/router/guards/require-place.guard.js';

/** Place-level operational routes — require active unit + navigation level. */
export function PlaceLevelOutlet() {
  return (
    <NavigationLevelGuard>
      <RequirePlace>
        <Outlet />
      </RequirePlace>
    </NavigationLevelGuard>
  );
}
